import { render, staticRenderFns } from "./SsToggleSwitch.vue?vue&type=template&id=74559334&scoped=true&"
import script from "./SsToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./SsToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SsToggleSwitch.vue?vue&type=style&index=0&id=74559334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74559334",
  null
  
)

export default component.exports